import { render, staticRenderFns } from "./NewCategoryMiniForm.vue?vue&type=template&id=45e686f1&"
import script from "./NewCategoryMiniForm.vue?vue&type=script&lang=js&"
export * from "./NewCategoryMiniForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports